import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

export const floatingMenuAnimation = trigger('floatingMenu', [
  state(
    'visible',
    style({
      transform: 'translateY(calc(-100% + 2px))',
      opacity: 1
    })
  ),
  state(
    'hidden',
    style({
      transform: 'translateY(0)',
      opacity: 0
    })
  ),
  transition('visible <=> hidden', [animate('0.2s ease-in-out')])
]);
